export const contractNumberPatterns = {
  production: /^([\dA-Z]{8})$/,
  uat: /^uat_([\dA-Z]{8})$/,
  test: /^test_([\dA-Z]{8})$/,
  demo: /^api_(\w*)/,
  sandbox: /^wize_(\w*)/
};
